<template>
  <v-list-item v-if="value || value === 0" :class="couleur">
    <v-list-item-content>{{ name }}</v-list-item-content>
    <v-list-item-content>{{ value }}</v-list-item-content>
  </v-list-item>
</template>

<script>
export default {
  name: "VueMyListItem",
  props: {
    name: {
      type: String,
      required: true,
    },
    value: {
      type: [String, Number],
      default: "",
    },
    couleur: {
      type: String,
      default: "",
    },
  },
};
</script>

<style scoped></style>
